<template>
  <div class="content-v2">
    <div class="structure-img" v-if="structureImage">
      <img :src="structureImage" alt="组织架构图" />
    </div>
    <div class="empty-v2" v-else>暂无组织架构图</div>
  </div>
</template>

<script>
import { getOrgList } from '@/api/portal'
import { resolveFileUrl } from '@/utils/request'

export default {
  name: 'AboutStructureV2',
  data() {
    return {
      structureImage: ''
    }
  },
  created() {
    getOrgList().then(list => {
      const item = (list || []).find(row => row.imageUrl)
      this.structureImage = item ? resolveFileUrl(item.imageUrl) : ''
    }).catch(() => {})
  }
}
</script>

<style lang="scss" scoped>
.structure-img {
  width: 100%;
  background: #fff;
  border: 1px solid #e2e8f0;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(15, 23, 42, 0.08);

  img {
    width: 100%;
    display: block;
  }
}

.empty-v2 {
  padding: 70px 24px;
  background: #fff;
  border: 1px solid #e2e8f0;
  color: #64748b;
  font-size: 16px;
  text-align: center;
}
</style>
